import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { IVisitReviewForm } from '@app/visit-reviews/models/visit-review-form.model';
import { inOutAnimation } from '@app/shared/utils';

@Component({
  selector: 'app-visit-review-add-form',
  templateUrl: './visit-review-add-form.component.html',
  styleUrls: ['./visit-review-add-form.component.scss'],
  animations: [inOutAnimation]
})
export class VisitReviewAddFormComponent {
  @Input() visitReviewFormData: IVisitReviewForm;
  @Output() formSubmitted = new EventEmitter<void>();

  readonly customerReviewTextLimit = 500;
  allGradesFilled: boolean;

  onFormSubmit(form: NgForm): void {
    this.allGradesFilled =
      this.visitReviewFormData.salonRating > 0 &&
      this.visitReviewFormData.employeesRating > 0 &&
      this.visitReviewFormData.treatmentRating > 0;

    if (form.valid && this.allGradesFilled) {
      this.formSubmitted.next();
    }
  }
}
